import { t } from 'i18next';

import LiveClassLessonsList from '../../../../components/LiveClassComponents/LessonsList/LiveClassLessonsList';
import Card from '../../../../components/Card/Card';
import Header from '../../../../components/LiveClassComponents/Header/Header';

import './students-dashboard.scoped.scss';

const Index = () => {
  return (
    <div className="m-3">
      <Card>
        <Card.Header>
          <Header title={t('common:classes')} showFullScreen={false} />
        </Card.Header>

        <Card.Body style={{ position: 'relative', padding: 0 }}>
          <div className="body-container p-1">
            <LiveClassLessonsList />
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Index;
